<div class="is-flex is-column gap-24">

  <section class="graph bg-body-card">
    <app-control-page-graph-header ></app-control-page-graph-header>
    <div class="subheader is-flex is-justify-space-between is-align-center">
      <app-control-page-graph-legend></app-control-page-graph-legend>
      <div class="is-flex is-align-center gap-24">
        <app-control-page-graph-minmax></app-control-page-graph-minmax>
        <app-control-page-graph-sum-rain></app-control-page-graph-sum-rain>
        <app-control-page-graph-max-wind></app-control-page-graph-max-wind>
      </div>
    </div>
    <app-control-page-graph></app-control-page-graph>
  </section>

  <section class="forecast bg-body-card" *ngIf="displayForecast$ | async">
    <app-control-page-forecast></app-control-page-forecast>
  </section>

  <section class="card-section is-flex is-fullwidth gap-24">
    <app-status-devices-card class="card" *ngIf="hasStatusDevices$ | async"></app-status-devices-card>

    <div class="card weathermap-card bg-body-card is-flex" *ngIf="displayForecast$ | async">
      <app-weathermap-card></app-weathermap-card>
    </div>

  </section>

</div>
